module.exports = function getResource(label) {
    let resources = {
        free: 'FREE'
    };

    return resources[label];
};
